import { SectionLabel, Reveal } from "./shared";

const CARDS = [
  { icon: "🧭", title: "A Clearer View", desc: "how a VA-backed purchase fits together as one deal" },
  { icon: "🧱", title: "The Better Deal Method™", desc: "Clarify → Structure → Guide, taught live" },
  { icon: "💬", title: "Questions To Ask", desc: "the ones that actually change your next move" },
  { icon: "📋", title: "An Optional Next Step", desc: "apply, then request your Better Deal Review™" },
];

export default function Takeaways() {
  return (
    <section className="py-24 lg:py-36 px-6 lg:px-10 bg-white/[0.015]" data-testid="takeaways-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionLabel n="007" text="THE TAKEAWAYS" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-12">
            WHAT YOU'LL WALK AWAY WITH
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {CARDS.map((c, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                className="h-full p-7 border border-white/10 bg-[#00224F]/40 hover:border-[#0162CA]/60 transition-colors duration-300"
                data-testid={`takeaway-card-${i + 1}`}
              >
                <div className="text-2xl mb-5">{c.icon}</div>
                <h3 className="font-bold text-base mb-2">{c.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
